<div class="chart">
  <div class="chart__bar" (clickOutside)="toggleTooltip()">
    <ng-container *ngFor="let it of iterations; index as i">
      <div
        *ngIf="values[i]"
        class="bar bar-animation"
        [ngClass]="{ 'hide-right-radius': hideRightRadius(i) }"
        [class.visible]="values[i].value > 0"
        [style.width]="values[i].width"
        (click)="toggleTooltip(values[i].name)"
      >
        <img *ngIf="values[i].icon" [src]="'/assets/images/' + values[i].icon" loading="lazy" alt="" />
        <span class="tooltip">{{ values[i].name }}<br />{{ values[i].value | round: -1 }} kg CO₂e </span>
      </div>
    </ng-container>
  </div>
</div>
